import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content"];

  connect() {
    console.log("Notifications controller connected");
  }

  loadContent(event) {
    // Load fresh notification content when dropdown opens
    console.log("Loading fresh notification content");

    fetch("/notifications/dropdown_content", {
      method: "GET",
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => response.text())
      .then((html) => {
        // Turbo will handle the stream response automatically
      })
      .catch((error) => {
        console.error("Error loading notifications:", error);
      });
  }

  // Turbo Streams will handle mark_as_read and mark_all_as_read automatically
  // through data-turbo-method="patch" attributes
}
